module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.26895",
      "ably": "static-2.2",
      "conversations-async-data": "static-2.6954",
      "conversations-error-reporting": "static-1.8226",
      "conversations-internal-pub-sub": "static-1.15312",
      "conversations-internal-schema": "static-1.11953",
      "conversations-message-history": "static-1.10480",
      "conversations-test-sdk": "static-1.9766",
      "conversations-visitor-experience-components": "static-1.20258",
      "head-dlb": "static-1.4360",
      "hs-promise-utils": "static-1.4831",
      "hs-test-utils": "static-1.7313",
      "hubspot-dlb": "static-2.1707",
      "HubStyleTokens": "static-2.10821",
      "I18n": "static-7.1450",
      "jasmine-immutable": "static-1.2272",
      "jasmine-runner": "static-1.5731",
      "quartz": "static-1.6112",
      "react-dlb": "static-1.61",
      "react-transition-group": "static-2.8",
      "redux-thunk": "static-2.43",
      "transmute": "static-2.75",
      "urlinator": "static-1.3846",
      "viral-links-lib": "static-1.6211",
      "visitor-ui-component-library": "static-1.5479",
      "webpack-env": "static-1.54",
      "ably-hubspot-js": "static-2.3874",
      "atom": "static-1.4458",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.4099",
      "conversations-infrastructure": "static-1.8246",
      "conversations-prop-types": "static-1.6751",
      "conversations-visibility-tools": "static-1.5077",
      "conversations-visitor-message-history": "static-1.18995",
      "cssUtils": "static-1.596",
      "enviro": "static-4.328",
      "flux-actions": "static-1.286",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.5499",
      "hubspot-url-utils": "static-1.3531",
      "immer": "static-1.33",
      "immutable": "static-2.19",
      "metrics-js": "static-1.9058",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.306",
      "raven": "static-3.5229",
      "react": "static-7.151",
      "react-aria": "static-1.44",
      "react-dom": "static-7.85",
      "react-redux": "static-7.16",
      "react-rhumb": "static-1.15899",
      "react-select-plus": "static-1.65",
      "react-utils": "static-2.4712",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize": "static-1.3683",
      "sanitize-text": "static-1.7460",
      "signup-constants": "static-1.17431",
      "styled-components": "static-2.64",
      "StyleGuideUI": "static-3.475",
      "usage-tracker": "static-1.6748",
      "usage-tracker-core": "static-1.6598",
      "usage-tracker-multi": "static-1.5162",
      "usage-tracker-public": "static-1.6559",
      "visitor-ui-component-library-icons": "static-1.5290",
      "hs-promise-rejection-tracking": "static-1.4750",
      "raven-hubspot": "static-1.5536",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.2859",
      "moment": "static-3.26",
      "quartz-core": "static-1.5331",
      "react-immutable-proptypes": "static-2.8",
      "foundations-assets": "static-1.4178",
      "foundations-components": "static-1.6800",
      "foundations-theming": "static-1.3646",
      "UIComponents": "static-3.7768",
      "cv-backend-services": "static-1.1323",
      "immutable-less": "static-1.3866",
      "conversations-skeleton-state": "static-1.6670",
      "icons": "static-2.593",
      "react-input-autosize": "static-2.17",
      "react-virtualized": "static-2.81",
      "rpc-client-utils": "static-1.4014",
      "ui-images": "static-2.961",
      "permission-components": "static-1.4663",
      "HeadJS": "static-2.622",
      "framer-motion": "static-1.52",
      "hs-test-utils-bend-plugin": "static-1.2424",
      "msw": "static-1.39",
      "testing-library": "static-1.134",
      "i18n-data": "static-1.207",
      "moment-timezone": "static-5.67",
      "jasmine": "static-4.3631",
      "quartz-core-utils": "static-1.2979",
      "signup-ui-url-generator": "static-2.7382",
      "HubStyle": "static-2.11129",
      "sassPrefix": "static-1.140",
      "csstype": "static-1.50",
      "history": "static-4.47",
      "usage-tracker-anonymous": "static-1.5165",
      "dispatcher": "static-1.121",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.696",
      "hub-http-shared-msw-handlers": "static-1.8326",
      "hubspotter-http": "static-1.3975",
      "hubspotter-http-shared-msw-handlers": "static-1.8324",
      "mobile-manifest-mixins": "static-1.393",
      "platform-navigation-bootstrap": "static-1.11796",
      "quick-fetch": "static-1.2772",
      "react-router-dom": "static-5.26",
      "ui-fonts": "static-1.333",
      "hs-story-utils": "static-1.8672",
      "bend-plugin-foundations-components": "static-1.3069",
      "floating-ui": "static-1.40",
      "foundations-theming-specialty": "static-1.1362",
      "tanstack-table": "static-1.23",
      "bend-plugin-foundations-theming": "static-1.2129",
      "foundations-theming-base": "static-1.2631",
      "ts-schema": "static-1.3501",
      "platform-infra-nav-components": "static-1.7085"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.26895",
      "ably": "/ably/static-2.2",
      "conversations-async-data": "/conversations-async-data/static-2.6954",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.8226",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.15312",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.11953",
      "conversations-message-history": "/conversations-message-history/static-1.10480",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.9766",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.20258",
      "head-dlb": "/head-dlb/static-1.4360",
      "hs-promise-utils": "/hs-promise-utils/static-1.4831",
      "hs-test-utils": "/hs-test-utils/static-1.7313",
      "hubspot-dlb": "/hubspot-dlb/static-2.1707",
      "HubStyleTokens": "/HubStyleTokens/static-2.10821",
      "I18n": "/I18n/static-7.1450",
      "jasmine-immutable": "/jasmine-immutable/static-1.2272",
      "jasmine-runner": "/jasmine-runner/static-1.5731",
      "quartz": "/quartz/static-1.6112",
      "react-dlb": "/react-dlb/static-1.61",
      "react-transition-group": "/react-transition-group/static-2.8",
      "redux-thunk": "/redux-thunk/static-2.43",
      "transmute": "/transmute/static-2.75",
      "urlinator": "/urlinator/static-1.3846",
      "viral-links-lib": "/viral-links-lib/static-1.6211",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5479",
      "webpack-env": "/webpack-env/static-1.54",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.3874",
      "atom": "/atom/static-1.4458",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.4099",
      "conversations-infrastructure": "/conversations-infrastructure/static-1.8246",
      "conversations-prop-types": "/conversations-prop-types/static-1.6751",
      "conversations-visibility-tools": "/conversations-visibility-tools/static-1.5077",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.18995",
      "cssUtils": "/cssUtils/static-1.596",
      "enviro": "/enviro/static-4.328",
      "flux-actions": "/flux-actions/static-1.286",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.5499",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3531",
      "immer": "/immer/static-1.33",
      "immutable": "/immutable/static-2.19",
      "metrics-js": "/metrics-js/static-1.9058",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.306",
      "raven": "/raven/static-3.5229",
      "react": "/react/static-7.151",
      "react-aria": "/react-aria/static-1.44",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.16",
      "react-rhumb": "/react-rhumb/static-1.15899",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-utils": "/react-utils/static-2.4712",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize": "/sanitize/static-1.3683",
      "sanitize-text": "/sanitize-text/static-1.7460",
      "signup-constants": "/signup-constants/static-1.17431",
      "styled-components": "/styled-components/static-2.64",
      "StyleGuideUI": "/StyleGuideUI/static-3.475",
      "usage-tracker": "/usage-tracker/static-1.6748",
      "usage-tracker-core": "/usage-tracker-core/static-1.6598",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.5162",
      "usage-tracker-public": "/usage-tracker-public/static-1.6559",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5290",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4750",
      "raven-hubspot": "/raven-hubspot/static-1.5536",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2859",
      "moment": "/moment/static-3.26",
      "quartz-core": "/quartz-core/static-1.5331",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "foundations-assets": "/foundations-assets/static-1.4178",
      "foundations-components": "/foundations-components/static-1.6800",
      "foundations-theming": "/foundations-theming/static-1.3646",
      "UIComponents": "/UIComponents/static-3.7768",
      "cv-backend-services": "/cv-backend-services/static-1.1323",
      "immutable-less": "/immutable-less/static-1.3866",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6670",
      "icons": "/icons/static-2.593",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-virtualized": "/react-virtualized/static-2.81",
      "rpc-client-utils": "/rpc-client-utils/static-1.4014",
      "ui-images": "/ui-images/static-2.961",
      "permission-components": "/permission-components/static-1.4663",
      "HeadJS": "/HeadJS/static-2.622",
      "framer-motion": "/framer-motion/static-1.52",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2424",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.134",
      "i18n-data": "/i18n-data/static-1.207",
      "moment-timezone": "/moment-timezone/static-5.67",
      "jasmine": "/jasmine/static-4.3631",
      "quartz-core-utils": "/quartz-core-utils/static-1.2979",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7382",
      "HubStyle": "/HubStyle/static-2.11129",
      "sassPrefix": "/sassPrefix/static-1.140",
      "csstype": "/csstype/static-1.50",
      "history": "/history/static-4.47",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5165",
      "dispatcher": "/dispatcher/static-1.121",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.696",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.8326",
      "hubspotter-http": "/hubspotter-http/static-1.3975",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.8324",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.393",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11796",
      "quick-fetch": "/quick-fetch/static-1.2772",
      "react-router-dom": "/react-router-dom/static-5.26",
      "ui-fonts": "/ui-fonts/static-1.333",
      "hs-story-utils": "/hs-story-utils/static-1.8672",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3069",
      "floating-ui": "/floating-ui/static-1.40",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1362",
      "tanstack-table": "/tanstack-table/static-1.23",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2129",
      "foundations-theming-base": "/foundations-theming-base/static-1.2631",
      "ts-schema": "/ts-schema/static-1.3501",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7085"
    },
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};